import { TOKEN_NAME, REFRESH_TOKEN_NAME, LOCALE_STORE_NAME } from '../config/consts';

const TokenService = {
    getToken() {
        return localStorage.getItem(TOKEN_NAME);
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_NAME, accessToken);
    },

    removeToken() {
        localStorage.removeItem(TOKEN_NAME);
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_NAME);
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_NAME, refreshToken);
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_NAME);
    }
};

const LocaleService = {
    locales: [{ id: 'kk-KZ', name: 'Қазақша', momentLocale: 'kz' }, { id: 'ru-KZ', name: 'Русский', momentLocale: 'ru' }],
    getLocale() {
        let locale = localStorage.getItem(LOCALE_STORE_NAME);
        return locale ? locale : 'ru-KZ';
    },
    getMomentLocale() {
        return this.getLocale();
    },

    setLocale(locale) {
        localStorage.setItem(LOCALE_STORE_NAME, locale);
    }
};

export { TokenService, LocaleService };
